var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSignupRedX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.55078 1.09961C1.56645 1.24063 1.90348 1.68995 2.01856 1.75571C2.33447 1.93624 2.67744 2.39428 2.92374 2.66697C3.50176 3.30692 4.19413 3.79564 4.77663 4.41051C5.07809 4.72871 5.48954 4.99789 5.76078 5.33695C5.93856 5.55917 6.27779 5.75267 6.41689 5.99609C6.64468 6.39473 7.13084 6.75865 7.45572 7.08352C7.59278 7.22058 7.67382 7.41097 7.81415 7.5513C7.89698 7.63414 8.00741 7.72519 8.05715 7.82468",
    stroke: "#FF002E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16646 1.1543C7.82153 1.49923 7.40369 1.78342 7.06081 2.1263C6.90861 2.2785 6.76815 2.46195 6.60518 2.60319C6.46074 2.72838 6.39407 2.88915 6.25283 3.01022C6.1113 3.13153 5.96454 3.25501 5.8701 3.42029C5.74079 3.64657 5.48402 3.8239 5.32334 4.02475C5.1032 4.29993 4.82982 4.54122 4.57004 4.77502C3.95739 5.32641 3.39481 5.89506 2.89333 6.53982C2.71108 6.77414 2.49782 6.9689 2.3162 7.19592C2.21482 7.32265 2.01519 7.40552 1.86057 7.52701C1.70535 7.64897 1.55295 7.85092 1.38672 7.93404",
    stroke: "#FF002E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSignupRedX);
export default __webpack_public_path__ + "static/media/icon-signup-redX.31b8fbf0203485c2ca498858a214ed87.svg";
export { ForwardRef as ReactComponent };